const emailAsterisk = value => {
  let splitEmail = value.split("@");
  let domain = splitEmail[1];
  let name = splitEmail[0];
  return name
    .substring(0, 3)
    .concat("*********@")
    .concat(domain);
};

export { emailAsterisk };
